<template>
    <!-- Sagdan acilan duzenleme paneli (modal-side): is emri/incident detayinda yalnizca atanan
         personel degistirilir, kaydin diger alanlari bu panelde hic yer almaz. -->
    <div tabindex="-1" class="modal modal-side fade" role="dialog" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <span v-lang.assign_staff></span>
                        <span class="text-primary" v-if="workOrderName">: {{workOrderName}}</span>
                        <code>{{workOrderId}}</code>
                    </h5>
                    <button type="button" class="close" data-dismiss="modal">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group m-form__group">
                        <label><span v-lang.master></span></label>
                        <multiselect v-model="selectedMasterUsers"
                                     :options="masterOptions"
                                     :multiple="true"
                                     :close-on-select="false"
                                     :clear-on-select="false"
                                     :hide-selected="true"
                                     :preserve-search="true"
                                     group-values="value"
                                     group-label="role"
                                     :group-select="true"
                                     track-by="Id"
                                     label="DisplayText"
                                     :placeholder="translate('master')"/>
                    </div>
                    <div class="form-group m-form__group">
                        <label><span v-lang.observer></span></label>
                        <multiselect v-model="selectedObserverUsers"
                                     :options="observerOptions"
                                     :multiple="true"
                                     :close-on-select="false"
                                     :clear-on-select="false"
                                     :hide-selected="true"
                                     :preserve-search="true"
                                     group-values="value"
                                     group-label="role"
                                     :group-select="true"
                                     track-by="Id"
                                     label="DisplayText"
                                     :placeholder="translate('observer')"/>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" v-lang.cancel></button>
                    <button type="button" class="btn btn-primary" @click="save()" v-lang.save></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import * as blockui from '../../../helpers/block-ui';
import * as swal from '../../../helpers/swal';
import { groupByRole } from '../../../scripts/global/util';
import { restoreWorkedUsers } from '../../../scripts/services/workOrderStatusPolicy';

export default {
  name: 'WorkOrderAssignUsersPanel',
  props: {
    workOrderId: {
      type: [Number, String],
      required: true,
    },
    // Yalnizca baslikta gosterilir.
    workOrderName: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      masterUsers: [],
      observerUsers: [],
      selectedMasterUsers: [],
      selectedObserverUsers: [],
    };
  },
  // Kayitta calismis personel atamadan cikarilamaz; dusen secim geri konur. Sunucu tarafi ayrica
  // zorluyor, bu yalnizca kullaniciyi bosa giden bir istekten kurtariyor.
  watch: {
    selectedMasterUsers(selected, previous) {
      const restored = restoreWorkedUsers(selected, previous);
      if (restored) {
        toastr.error(this.translate('worked_staff_cannot_be_removed'));
        this.selectedMasterUsers = restored;
      }
    },
    selectedObserverUsers(selected, previous) {
      const restored = restoreWorkedUsers(selected, previous);
      if (restored) {
        toastr.error(this.translate('worked_staff_cannot_be_removed'));
        this.selectedObserverUsers = restored;
      }
    },
  },
  methods: {
    async open() {
      await this.initializeData();
      $(this.$el).modal('show');
    },
    close() {
      $(this.$el).modal('hide');
    },
    async initializeData() {
      const self = this;
      blockui.pageBlock(self);
      try {
        const response = await self.$globalApiClient.workOrderUser.workOrderUserGetSuitableWorkUsers({
          workOrderId: self.workOrderId,
        });
        const users = response.data || [];

        self.masterUsers = users.filter((user) => user.IsAssignableToMaster)
          .map((user) => self.toOption(user, user.IsTrainedForMaster));
        self.observerUsers = users.filter((user) => user.IsAssignableToObserver)
          .map((user) => self.toOption(user, user.IsTrainedForObserver));

        // Mevcut atamalar ayni yanittan geliyor; ikinci bir istek gerekmiyor.
        self.selectedMasterUsers = self.masterUsers.filter((user) => user.IsMaster);
        self.selectedObserverUsers = self.observerUsers.filter((user) => user.IsObserver);
      } catch (e) {
        toastr.error(e.message);
      } finally {
        blockui.unBlockPage();
      }
    },
    // Ad yaninda egitim/vardiya/uygunluk durumu gosterilir; bunlar atamayi engellemez, yalnizca
    // bilgilendirir - sunucu da bunlari filtre olarak kullanmiyor, listeyi rol belirliyor.
    toOption(user, isTrained) {
      const training = `${this.translate('training')}: ${isTrained ? this.translate('yes') : this.translate('no')}`;
      const shift = `${this.translate('shift')}: ${user.IsHaveShift ? this.translate('yes') : this.translate('no')}`;
      const workload = user.IsHaveWorkOrder ? this.translate('busy') : this.translate('available');

      return { ...user, DisplayText: `${user.Name} (${training} - ${shift} - ${workload})` };
    },
    async save() {
      const self = this;
      const selectedMasterIds = self.selectedMasterUsers.map((user) => user.Id);
      const selectedObserverIds = self.selectedObserverUsers.map((user) => user.Id);
      const selectedIds = new Set([...selectedMasterIds, ...selectedObserverIds]);
      const removedUserIds = [...self.initialMasterUserIds, ...self.initialObserverUserIds]
        .filter((userId) => !selectedIds.has(userId));

      blockui.pageBlock(self);
      try {
        // Once cikarilanlar: bir kullanici ayni anda iki pozisyonda olamiyor, pozisyon
        // degistirenlerin once silinmesi gerekiyor.
        for (const userId of removedUserIds) {
          await self.deleteUser(userId);
        }
        // Sunucu, usta atanmadan refakatci eklenmesine izin vermiyor; once ustalar.
        await self.saveNewUsers(selectedMasterIds, self.initialMasterUserIds, self.enumUserPositions.master);
        await self.saveNewUsers(selectedObserverIds, self.initialObserverUserIds, self.enumUserPositions.observer);
      } finally {
        blockui.unBlockPage();
      }

      self.$emit('saved');
      self.close();
    },
    async saveNewUsers(selectedUserIds, initialUserIds, userPositionId) {
      for (const userId of selectedUserIds.filter((id) => !initialUserIds.includes(id))) {
        await this.saveUser(userId, userPositionId);
      }
    },
    async saveUser(userId, userPositionId, forceSave = false) {
      const self = this;
      const workOrderUser = {
        WorkOrderId: Number(self.workOrderId),
        UserId: userId,
        UserPositionId: userPositionId,
      };
      const response = await self.$globalApiClient.workOrderUser.workOrderUserSave(workOrderUser, { forceSave });
      if (response.data.IsSuccess) {
        return true;
      }
      if (forceSave) {
        toastr.error(response.data.Message);
        return false;
      }
      // Mesai/is emri cakismasi ya da freeze donemi: kullaniciya sorulur, onaylarsa zorlanir. Sunucu
      // mesaji satirlari </br> ile kiriyor; AddWorkOrder'daki gibi HTML olarak gosterilir.
      const swalResponse = await swal.checkWithHtmlContent(self, self.translate('work_order_time_conflict_title'), response.data.Message);
      return swalResponse.value ? self.saveUser(userId, userPositionId, true) : false;
    },
    async deleteUser(userId) {
      const response = await this.$globalApiClient.workOrderUser.workOrderUserDeleteWorkOrderUsers({
        WorkOrderId: Number(this.workOrderId),
        UserId: userId,
      });
      if (!response.data.IsSuccess) {
        toastr.error(response.data.Message);
        return false;
      }
      return true;
    },
  },
  computed: {
    ...mapState({
      enumUserPositions: (state) => state.enums.userPositions,
    }),
    masterOptions() {
      return groupByRole(this.masterUsers);
    },
    observerOptions() {
      return groupByRole(this.observerUsers);
    },
    // Kaydederken fark alinir: yalnizca yeni eklenenler kaydedilir, cikarilanlar silinir.
    initialMasterUserIds() {
      return this.masterUsers.filter((user) => user.IsMaster).map((user) => user.Id);
    },
    initialObserverUserIds() {
      return this.observerUsers.filter((user) => user.IsObserver).map((user) => user.Id);
    },
  },
};
</script>
